import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const LOGO_SRC = "/logo-mehul-jlec.png";

type BrandLogoSize = "sm" | "md" | "lg" | "xl";

const sizeMap: Record<BrandLogoSize, { img: number; text: string }> = {
  sm: { img: 28, text: "text-sm" },
  md: { img: 36, text: "text-lg" },
  lg: { img: 44, text: "text-xl" },
  xl: { img: 96, text: "text-2xl" },
};

interface BrandLogoProps {
  className?: string;
  size?: BrandLogoSize;
  showText?: boolean;
  textClassName?: string;
  asLinkTo?: string;
  /** when true, use light text (e.g. on maroon header) */
  variant?: "default" | "onDark";
}

export function BrandLogo({
  className,
  size = "md",
  showText = true,
  textClassName,
  asLinkTo,
  variant = "default",
}: BrandLogoProps) {
  const { img, text: textSize } = sizeMap[size];
  const inner = (
    <>
      <img
        src={LOGO_SRC}
        width={img}
        height={img}
        alt="Mehul Japanese Language Education Center"
        className="object-contain shrink-0 rounded-full shadow-sm"
      />
      {showText && (
        <span
          className={cn(
            "font-heading font-bold tracking-tight leading-none normal-case",
            textSize,
            variant === "onDark" ? "text-white" : "text-foreground",
            textClassName,
          )}
        >
          Mehul
        </span>
      )}
    </>
  );

  if (asLinkTo) {
    return (
      <Link to={asLinkTo} className={cn("inline-flex items-center gap-2.5", className)}>
        {inner}
      </Link>
    );
  }
  return <span className={cn("inline-flex items-center gap-2.5", className)}>{inner}</span>;
}
